export default __webpack_public_path__ + "static/media/sobre.f4cac8e4.png";